// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MultivariateAnalysis_main-wrapper__EWbzS {
  background-color: #f9fafb;
  min-height: 100vh;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.MultivariateAnalysis_chart-container__VASHK {
  background-color: white;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  width: 100%;
  max-width: 1280px;
}

.MultivariateAnalysis_controls-wrapper__9RSW2 {
  display: flex;
  gap: 1.25rem;
  overflow-x: auto;
  margin-bottom: 1rem;
  margin-left: 1.25rem;
  margin-top: 1.25rem;
}

.MultivariateAnalysis_control-item__PDjT9 {
  display: flex;
  flex-direction: column;
  min-width: 160px;
  padding-top: 15px;
}

.MultivariateAnalysis_control-item__PDjT9 label {
  font-size: 14px;
  margin-bottom: 6px;
  color: #374151;
}

.MultivariateAnalysis_control-item__PDjT9 select {
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.MultivariateAnalysis_control-item-axis__BjiIK {
  display: flex;
  flex-direction: column;
  min-width: 40px;
  padding-top: 15px;

}

.MultivariateAnalysis_checkbox-wrapper__i4ORF {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  /* color: #374151;
    flex-direction: column;
    justify-content: flex-end;
    min-width: 140px; */
}

/* .checkbox-wrapper input[type="checkbox"] {
    width: 18px;
    height: 18px;
}

.checkbox-label {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
} */

.MultivariateAnalysis_toggle-wrapper__c9x58 {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-size: 14px;
}

/* Hide default checkbox */
.MultivariateAnalysis_toggle-wrapper__c9x58 input[type="checkbox"] {
  display: none;
}

/* Track with labels inside */
.MultivariateAnalysis_toggle-slider__c3koL {
  position: relative;
  width: 70px;
  height: 36px;
  background-color: #d1d5db;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6px;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.3s;
}

/* Knob */
.MultivariateAnalysis_toggle-slider__c3koL::before {
  content: "";
  position: absolute;
  width: 32px;
  height: 32px;
  top: 2px;
  left: 2px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.25s cubic-bezier(0.68, -0.55, 0.265, 1.55), box-shadow 0.2s;
  /* springy animation */
  z-index: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* Hover effect on knob */
.MultivariateAnalysis_toggle-wrapper__c9x58:hover .MultivariateAnalysis_toggle-slider__c3koL::before {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
}

/* Labels inside track */
.MultivariateAnalysis_toggle-slider__c3koL span {
  position: relative;
  z-index: 2;
  width: 50%;
  text-align: center;
  color: #374151;
  transition: color 0.3s;
}

/* Checked state */
.MultivariateAnalysis_toggle-wrapper__c9x58 input[type="checkbox"]:checked+.MultivariateAnalysis_toggle-slider__c3koL {
  background-color: #22c55e;
}

.MultivariateAnalysis_toggle-wrapper__c9x58 input[type="checkbox"]:checked+.MultivariateAnalysis_toggle-slider__c3koL::before {
  transform: translateX(34px);
  /* springy slide */
}

/* Active label highlighting */
.MultivariateAnalysis_toggle-wrapper__c9x58 input[type="checkbox"]:not(:checked)+.MultivariateAnalysis_toggle-slider__c3koL span:first-child {
  color: white;
  /* active 2D */
}

.MultivariateAnalysis_toggle-wrapper__c9x58 input[type="checkbox"]:not(:checked)+.MultivariateAnalysis_toggle-slider__c3koL span:last-child {
  color: #ffffffaa;
  /* inactive 3D faded */
}

.MultivariateAnalysis_toggle-wrapper__c9x58 input[type="checkbox"]:checked+.MultivariateAnalysis_toggle-slider__c3koL span:first-child {
  color: #ffffffaa;
  /* inactive 2D faded */
}

.MultivariateAnalysis_toggle-wrapper__c9x58 input[type="checkbox"]:checked+.MultivariateAnalysis_toggle-slider__c3koL span:last-child {
  color: white;
  /* active 3D */
}


.MultivariateAnalysis_checkbox-label__2mSXl span {
  margin-left: 8px;
  font-size: 13px;
  color: #374151;
}

.MultivariateAnalysis_control-item__PDjT9 input[type=checkbox] {
  width: 18px;
  height: 18px;
}

.MultivariateAnalysis_chart-wrapper__7oQ92 {
  background: #f9fafb;
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid #e5e7eb;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
}

.MultivariateAnalysis_heatmap-wrapper__BLuXA {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;
}

.MultivariateAnalysis_plot-wrapper__2tVOz {
  width: 100%;
  height: 55vh;
}

.MultivariateAnalysis_plot-wrapper-3d__DYJo7 {
  height: 70vh;
}

.MultivariateAnalysis_tooltip-box__WVMi7 {
  background-color: white;
  border: 1px solid #ccc;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 13px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
}

.MultivariateAnalysis_tooltip-title__qvAEu {
  font-weight: bold;
}

.MultivariateAnalysis_tooltip-efficient__zpz1K {
  color: #22c55e;
}

.MultivariateAnalysis_tooltip-inefficient__wstb6 {
  color: #ef4444;
}

.MultivariateAnalysis_d3-tooltip__W9aHc {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  background-color: #f9fafb;
  border: 1px solid #d1d5db;
  padding: 8px;
  border-radius: 6px;
  color: #111827;
}

.MultivariateAnalysis_loading__2a0TB {
  padding: 20px;
  text-align: center;
  color: #374151;
}

.MultivariateAnalysis_height-300__HO6UU {
  /* color: #374151; */
  font-size: 24px;
  background-color: #c6ced9;
  margin: 0 20px 20px 20px;
  height: 16rem;
}

.MultivariateAnalysis_filter_dropdown__scuTJ {
  border-radius: 5px;
  border-color: #e7eaee !important;
  /* border: #031222 !important; */
  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);
  font-size: 13px;
  padding-top: 7px;
  padding-bottom: 7px;

}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/Mileagesaarathi_bus/MultivariateAnalysisTab_bus/MultivariateAnalysis.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf;;;uBAGqB;AACvB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA,SAAS;AACT;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mFAAmF;EACnF,sBAAsB;EACtB,UAAU;EACV,wCAAwC;AAC1C;;AAEA,yBAAyB;AACzB;EACE,yCAAyC;AAC3C;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;;AAGA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;;AAErB","sourcesContent":[".main-wrapper {\n  background-color: #f9fafb;\n  min-height: 100vh;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.chart-container {\n  background-color: white;\n  padding: 2rem;\n  border-radius: 1rem;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n  width: 100%;\n  max-width: 1280px;\n}\n\n.controls-wrapper {\n  display: flex;\n  gap: 1.25rem;\n  overflow-x: auto;\n  margin-bottom: 1rem;\n  margin-left: 1.25rem;\n  margin-top: 1.25rem;\n}\n\n.control-item {\n  display: flex;\n  flex-direction: column;\n  min-width: 160px;\n  padding-top: 15px;\n}\n\n.control-item label {\n  font-size: 14px;\n  margin-bottom: 6px;\n  color: #374151;\n}\n\n.control-item select {\n  padding: 8px;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n}\n\n.control-item-axis {\n  display: flex;\n  flex-direction: column;\n  min-width: 40px;\n  padding-top: 15px;\n\n}\n\n.checkbox-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  /* color: #374151;\n    flex-direction: column;\n    justify-content: flex-end;\n    min-width: 140px; */\n}\n\n/* .checkbox-wrapper input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n}\n\n.checkbox-label {\n    display: inline-flex;\n    align-items: center;\n    cursor: pointer;\n} */\n\n.toggle-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n/* Hide default checkbox */\n.toggle-wrapper input[type=\"checkbox\"] {\n  display: none;\n}\n\n/* Track with labels inside */\n.toggle-slider {\n  position: relative;\n  width: 70px;\n  height: 36px;\n  background-color: #d1d5db;\n  border-radius: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 6px;\n  box-sizing: border-box;\n  font-size: 14px;\n  font-weight: bold;\n  transition: background-color 0.3s;\n}\n\n/* Knob */\n.toggle-slider::before {\n  content: \"\";\n  position: absolute;\n  width: 32px;\n  height: 32px;\n  top: 2px;\n  left: 2px;\n  background-color: white;\n  border-radius: 50%;\n  transition: transform 0.25s cubic-bezier(0.68, -0.55, 0.265, 1.55), box-shadow 0.2s;\n  /* springy animation */\n  z-index: 1;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n/* Hover effect on knob */\n.toggle-wrapper:hover .toggle-slider::before {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);\n}\n\n/* Labels inside track */\n.toggle-slider span {\n  position: relative;\n  z-index: 2;\n  width: 50%;\n  text-align: center;\n  color: #374151;\n  transition: color 0.3s;\n}\n\n/* Checked state */\n.toggle-wrapper input[type=\"checkbox\"]:checked+.toggle-slider {\n  background-color: #22c55e;\n}\n\n.toggle-wrapper input[type=\"checkbox\"]:checked+.toggle-slider::before {\n  transform: translateX(34px);\n  /* springy slide */\n}\n\n/* Active label highlighting */\n.toggle-wrapper input[type=\"checkbox\"]:not(:checked)+.toggle-slider span:first-child {\n  color: white;\n  /* active 2D */\n}\n\n.toggle-wrapper input[type=\"checkbox\"]:not(:checked)+.toggle-slider span:last-child {\n  color: #ffffffaa;\n  /* inactive 3D faded */\n}\n\n.toggle-wrapper input[type=\"checkbox\"]:checked+.toggle-slider span:first-child {\n  color: #ffffffaa;\n  /* inactive 2D faded */\n}\n\n.toggle-wrapper input[type=\"checkbox\"]:checked+.toggle-slider span:last-child {\n  color: white;\n  /* active 3D */\n}\n\n\n.checkbox-label span {\n  margin-left: 8px;\n  font-size: 13px;\n  color: #374151;\n}\n\n.control-item input[type=checkbox] {\n  width: 18px;\n  height: 18px;\n}\n\n.chart-wrapper {\n  background: #f9fafb;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  border: 1px solid #e5e7eb;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.heatmap-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: auto;\n}\n\n.plot-wrapper {\n  width: 100%;\n  height: 55vh;\n}\n\n.plot-wrapper-3d {\n  height: 70vh;\n}\n\n.tooltip-box {\n  background-color: white;\n  border: 1px solid #ccc;\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 13px;\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.tooltip-title {\n  font-weight: bold;\n}\n\n.tooltip-efficient {\n  color: #22c55e;\n}\n\n.tooltip-inefficient {\n  color: #ef4444;\n}\n\n.d3-tooltip {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n  background-color: #f9fafb;\n  border: 1px solid #d1d5db;\n  padding: 8px;\n  border-radius: 6px;\n  color: #111827;\n}\n\n.loading {\n  padding: 20px;\n  text-align: center;\n  color: #374151;\n}\n\n.height-300 {\n  /* color: #374151; */\n  font-size: 24px;\n  background-color: #c6ced9;\n  margin: 0 20px 20px 20px;\n  height: 16rem;\n}\n\n.filter_dropdown {\n  border-radius: 5px;\n  border-color: #e7eaee !important;\n  /* border: #031222 !important; */\n  box-shadow: 0 1px 1px 1px rgba(0, 0, 0, 0.08);\n  font-size: 13px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main-wrapper": `MultivariateAnalysis_main-wrapper__EWbzS`,
	"chart-container": `MultivariateAnalysis_chart-container__VASHK`,
	"controls-wrapper": `MultivariateAnalysis_controls-wrapper__9RSW2`,
	"control-item": `MultivariateAnalysis_control-item__PDjT9`,
	"control-item-axis": `MultivariateAnalysis_control-item-axis__BjiIK`,
	"checkbox-wrapper": `MultivariateAnalysis_checkbox-wrapper__i4ORF`,
	"toggle-wrapper": `MultivariateAnalysis_toggle-wrapper__c9x58`,
	"toggle-slider": `MultivariateAnalysis_toggle-slider__c3koL`,
	"checkbox-label": `MultivariateAnalysis_checkbox-label__2mSXl`,
	"chart-wrapper": `MultivariateAnalysis_chart-wrapper__7oQ92`,
	"heatmap-wrapper": `MultivariateAnalysis_heatmap-wrapper__BLuXA`,
	"plot-wrapper": `MultivariateAnalysis_plot-wrapper__2tVOz`,
	"plot-wrapper-3d": `MultivariateAnalysis_plot-wrapper-3d__DYJo7`,
	"tooltip-box": `MultivariateAnalysis_tooltip-box__WVMi7`,
	"tooltip-title": `MultivariateAnalysis_tooltip-title__qvAEu`,
	"tooltip-efficient": `MultivariateAnalysis_tooltip-efficient__zpz1K`,
	"tooltip-inefficient": `MultivariateAnalysis_tooltip-inefficient__wstb6`,
	"d3-tooltip": `MultivariateAnalysis_d3-tooltip__W9aHc`,
	"loading": `MultivariateAnalysis_loading__2a0TB`,
	"height-300": `MultivariateAnalysis_height-300__HO6UU`,
	"filter_dropdown": `MultivariateAnalysis_filter_dropdown__scuTJ`
};
export default ___CSS_LOADER_EXPORT___;
